export default __webpack_public_path__ + "static/media/303.53e111d4.gif";